export var makeSkeletonStyles = function makeSkeletonStyles(_ref) {
  var tokens = _ref.tokens;
  return {
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: tokens.colors["fill-soft-gray-transparent"]
        }
      }
    }
  };
};